<script setup lang="ts">
import { KsDialogClose } from '@aschehoug/kloss-2'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faClose } from '@fortawesome/pro-regular-svg-icons'
</script>

<template>
  <KsDialogClose
    class="dialog-close"
    as-child
  >
    <slot>
      <CommonButton
        is-on-dark
        shape="icon"
      >
        <FontAwesomeIcon :icon="faClose" />
      </CommonButton>
    </slot>
  </KsDialogClose>
</template>
